import { render, staticRenderFns } from "./RecurringOrderList.vue?vue&type=template&id=5dd8555a&scoped=true&"
import script from "./RecurringOrderList.vue?vue&type=script&lang=ts&"
export * from "./RecurringOrderList.vue?vue&type=script&lang=ts&"
import style0 from "./RecurringOrderList.vue?vue&type=style&index=0&id=5dd8555a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8555a",
  null
  
)

export default component.exports